import { createStyles } from 'antd-style';

export const useNewPasswordFieldStyles = createStyles(() => ({
  newPasswordField: {
    '&&': {
      '.ant-form-item .ant-form-item-explain': {
        display: 'none',
      },
    },
  },
}));
